/**
 * True when code is running in tal-core's SSR environment: the browser bundle is evaled
 * inside JSDOM (so window/document exist) and tal-core sets window.oetal.ssr.onServer = true.
 * Use this together with typeof window !== "undefined" when deciding client-only behaviour
 * (e.g. emotion cache): Node has no window; JSDOM has window but isOnServer() is true.
 */
type GlobalWithWindow = typeof globalThis & { window?: Window };

export function isOnServer(): boolean {
  const win = (globalThis as GlobalWithWindow)?.window;
  return (
    typeof win?.oetal?.ssr?.onServer === "boolean" && win.oetal.ssr.onServer
  );
}

export function shouldInitialize(): boolean {
  // Do not initialise client-only features during SSR. tal-core runs the bundle with a fake
  // JSDOM window and sets window.oetal.ssr.onServer = true; without this check we could
  // still pass the pathname check below and trigger code that fetches (e.g. Survicate, logger).
  if (isOnServer()) {
    return false;
  }

  const platformApps = [
    "/auth/callback",
    "/logout",
    "/auth/ml",
    "/auth/sml",
    "/my-account/contexthub",
  ];

  // Use globalThis so that there isn't a undeclared "window" variable in a node context (SSR)
  const pathName = globalThis?.window?.location?.pathname;
  if (!pathName) {
    return false;
  }

  const isPlatformApp = platformApps.some((app) => app === pathName);

  // Do not initialise for platform specific and kraken apps
  if (isPlatformApp) {
    return false;
  }

  return true;
}
